<script setup lang="ts">
import VAffiliateProfileUpdateForm from '@modules/affiliates-approved/submodules/affiliate-profile/components/VAffiliateProfileUpdateForm/VAffiliateProfileUpdateForm.vue';
import { useAffiliateProfileUpdate } from '@modules/affiliates-approved/submodules/affiliate-profile/composables';
import {
  AFFILIATES_APPROVED_PROFILE_PERMISSIONS,
} from '@modules/affiliates-approved/submodules/affiliate-profile/constants';

import { TRANSLATION_GROUP_AFFILIATE_PROFILE_CONTACTS } from '../../constants';

const {
  contactsSchema,
  profileErrors,
  isOptionsLoading,
  isProfileUpdateLoading,
  onSubmitContacts,
  clearProfileError,
} = useAffiliateProfileUpdate(TRANSLATION_GROUP_AFFILIATE_PROFILE_CONTACTS);
</script>

<template>
  <VAffiliateProfileUpdateForm v-data-qa-auto-id="'ProfileContactsPage'"
    :form-schema="contactsSchema"
    :errors="profileErrors"
    :readonly="!$hasPermission(AFFILIATES_APPROVED_PROFILE_PERMISSIONS.EDIT)"
    :is-data-loading="isOptionsLoading"
    :is-update-loading="isProfileUpdateLoading"
    @submit="onSubmitContacts"
    @interacted="clearProfileError"
  />
</template>
